import api from './api';

const usersService = {
  /**
   * Listar todos os usuários (Admin/Superadmin)
   */
  async getAll() {
    const response = await api.get('/users');
    return response.data;
  },

  /**
   * Obter um usuário por ID
   */
  async getById(id) {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  /**
   * Criar um novo usuário (Superadmin)
   */
  async create(userData) {
    const response = await api.post('/users', userData);
    return response.data;
  },

  /**
   * Atualizar um usuário (Superadmin)
   */
  async update(id, userData) {
    const response = await api.patch(`/users/${id}`, userData);
    return response.data;
  },

  /**
   * Remover um usuário (Superadmin)
   */
  async delete(id) {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  /**
   * Obter perfil do usuário logado
   */
  async getProfile() {
    const response = await api.get('/users/profile');
    return response.data;
  },

  /**
   * Atualizar perfil do usuário logado
   */
  async updateProfile(profileData) {
    const response = await api.patch('/users/profile', profileData);
    // Atualiza os dados no localStorage se o update for bem sucedido
    if (response.data) {
      localStorage.setItem('ggmf_user', JSON.stringify(response.data));
    }
    return response.data;
  },
};

export default usersService;
